import { GetHandleProps, SliderItem } from "react-compound-slider";
import { useTranslation } from "react-i18next";

interface IHandleProps {
  domain: number[];
  handle: SliderItem;
  getHandleProps: GetHandleProps;
  disable?: boolean;
}

export const Handle = ({
  domain: [min, max],
  handle: { id, value, percent },
  getHandleProps,
  disable = false,
}: IHandleProps) => {
  const { t } = useTranslation();
  const label = t(id === "$$-0" ? "formsV2.rainySeasonStart" : "formsV2.drySeasonStart");
  return (
    <div
      role="slider"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      aria-label={label}
      style={{
        left: `${percent}%`,
        cursor: disable ? "default" : "pointer",
      }}
      {...(!disable && getHandleProps(id))}
      className={`indicadorTempo ${
        id === "$$-0" ? "pontoInicioChuva" : "pontoInicioSeca"
      }`}
    >
      <div
        className={`tagPonto ${
          id === "$$-0" ? "avisoInicioChuva" : "avisoInicioSeca"
        }`}
      >
        <h2 className="textSlider">{label}</h2>
      </div>
    </div>
  );
};
